import AccountTokenCheck from './container'

export default AccountTokenCheck
